import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

export const AWARDS_ROUTE_ELEMENT_ID = 'awardsRoute'

const ConfigureAwardTypeRoute = lazyWithRetries(() => import('./configure'))
const ConfigureNominationTypeRoute = lazyWithRetries(() => import('./nominations/configure'))
const AwardsRoute = lazyWithRetries(() => import('.'))
const ViewAwardRoute = lazyWithRetries(() => import('./award'))
const ViewNominationRoute = lazyWithRetries(() => import('./nomination'))
const ViewNomineeRoute = lazyWithRetries(() => import('./nomination/nominee'))
const BulkSendAwardRoute = lazyWithRetries(() => import('./bulkSendAward'))

const bulkSendAwardElement = (
  <StandardPageLayout
    title={<T _str="Bulk send award" />}
    maxWidth={1080}
    elementId="bulkAwardSend">
    <Suspense fallback={<RouteLoading />}>
      <BulkSendAwardRoute />
    </Suspense>
  </StandardPageLayout>
)

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.configureAwardType(),
    element: (
      <StandardPageLayout maxWidth={900} elementId="createAwardTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ConfigureAwardTypeRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureAwardType(':awardTypeId'),
    element: (
      <StandardPageLayout maxWidth={900} elementId="editAwardTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ConfigureAwardTypeRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureNomination(),
    element: (
      <StandardPageLayout maxWidth={900} elementId="createNominationTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ConfigureNominationTypeRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.configureNomination(':nominationId'),
    element: (
      <StandardPageLayout maxWidth={900} elementId="editNominationTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ConfigureNominationTypeRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.bulkSendAward(),
    element: bulkSendAwardElement,
  },
  {
    path: AppPaths.tenant.admin.bulkSendAward(':batchId'),
    element: bulkSendAwardElement,
  },
  {
    path: AppPaths.tenant.admin.awards(':subTab?'),
    element: (
      <StandardPageLayout
        maxWidth={1080}
        title={<T _str="Awards & nominations" />}
        elementId={AWARDS_ROUTE_ELEMENT_ID}>
        <Suspense fallback={<RouteLoading />}>
          <AwardsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.viewAwardType(':awardTypeId'),
    element: (
      <StandardPageLayout maxWidth={1080} elementId="viewAwardTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ViewAwardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.viewNominationAwardType(':awardTypeId'),
    element: (
      <StandardPageLayout maxWidth={1080} elementId="viewNominationAwardTypeRoute">
        <Suspense fallback={<RouteLoading />}>
          <ViewNominationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.viewNominee(':awardTypeId', ':nomineeId'),
    element: (
      <StandardPageLayout maxWidth={600} elementId="viewQuestionResponsesRoute">
        <Suspense fallback={<RouteLoading />}>
          <ViewNomineeRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
